var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ext-btns inline m-r"})
}
var staticRenderFns = []

export { render, staticRenderFns }